export const anpPricesDefaultColumns = [
  { value: 'product_display_name', label: 'Produto' },
  { value: 'min_resale_price', label: 'Valor mínimo' },
  { value: 'average_resale_price', label: 'Valor médio' },
  { value: 'max_resale_price', label: 'Valor máximo' },
];

export const anpPricesByGeoTypeColumns = {
  'Geo::City': [
    { value: 'product_display_name', label: 'Produto' },
    { value: 'geo_parent_display_name', label: 'Estado' },
    { value: 'geo_display_name', label: 'Município' },
    { value: 'min_resale_price', label: 'Valor mínimo' },
    { value: 'average_resale_price', label: 'Valor médio' },
    { value: 'max_resale_price', label: 'Valor máximo' },
  ],
  'Geo::State': [
    { value: 'product_display_name', label: 'Produto' },
    { value: 'geo_parent_display_name', label: 'Região' },
    { value: 'geo_display_name', label: 'Estado' },
    { value: 'min_resale_price', label: 'Valor mínimo' },
    { value: 'average_resale_price', label: 'Valor médio' },
    { value: 'max_resale_price', label: 'Valor máximo' },
  ],
  'Geo::Region': [
    { value: 'product_display_name', label: 'Produto' },
    { value: 'geo_parent_display_name', label: 'País' },
    { value: 'geo_display_name', label: 'Região' },
    { value: 'min_resale_price', label: 'Valor mínimo' },
    { value: 'average_resale_price', label: 'Valor médio' },
    { value: 'max_resale_price', label: 'Valor máximo' },
  ],
  'Geo::Country': [
    { value: 'product_display_name', label: 'Produto' },
    { value: 'geo_display_name', label: 'País' },
    { value: 'min_resale_price', label: 'Valor mínimo' },
    { value: 'average_resale_price', label: 'Valor médio' },
    { value: 'max_resale_price', label: 'Valor máximo' },
  ],
};

